import React, { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import BuildingPage from "../BuildingPage";
import ProtectedRoute from "../../../components/ProtectedRoute";
import WelcomePage from "../WelcomePage";

const EmbarcadorProgramacaoPage = lazy(() => import("./programacao/ProgramacaoPage"));

const EmbarcadorAgendamentosPage = lazy(() => import("./agendamentos/AgendamentosPage"));

const EmbarcadorPainelOfertaPage = lazy(() => import("./painel-oferta/PainelOfertaPage"));

const EmbarcadorTorrePage = lazy(() => import("./torre/TorrePage"));

const EmbarcadorFretePage = lazy(() => import("./frete/FretePage"));

const EmbarcadoraFavoritoPage = lazy(() => import("./favorito/FavoritoPage"));

const EmbarcadoraColaborador = lazy(() => import("./colaborador/ColaboradorPage"));

const EmbarcadoraGruposAcesso = lazy(() => import("./group/GroupPage"));

const EmbarcadoraPerfil = lazy(() => import("./perfil/PerfilPage"));

const EmbarcadoraMeuPerfil = lazy(() => import("./meuPerfil/MeuPerfilPage"));

const EmbarcadoraLocais = lazy(() => import("./locais/LocaisPage"));

const EmbarcadoraPatio = lazy(() => import("./patio/PatioPage"));

const EmbarcadoraParametrosOperacionaisPage = lazy(() => import("./turno/ParametrosOperacionaisPage"));

export default function EmbarcadoraRoutes() {
  return (
    <Switch>
      <Route exact path="/" component={WelcomePage} />

      <Route path="/embarcador/dashboard" component={BuildingPage} />
      <Route path="/embarcador/parametros-operacionais" component={EmbarcadoraParametrosOperacionaisPage} />
      <Redirect from="/embarcador/programacao/configuracao/turnos" to="/embarcador/parametros-operacionais/turnos" />
      <Redirect from="/embarcador/programacao/configuracao/reservas" to="/embarcador/parametros-operacionais/reservas" />
      <Redirect from="/embarcador/programacao/configuracao/agendamento" to="/embarcador/parametros-operacionais/agendamento" />
      <Redirect from="/embarcador/programacao/configuracao" to="/embarcador/parametros-operacionais/turnos" />
      <Route path="/embarcador/programacao" component={EmbarcadorProgramacaoPage} />
      <Route path="/embarcador/agendamentos" component={EmbarcadorAgendamentosPage} />
      <Route path="/embarcador/painel-oferta" component={EmbarcadorPainelOfertaPage} />
      <Route path="/embarcador/torre" component={EmbarcadorTorrePage} />
      <Route path="/embarcador/frete" component={EmbarcadorFretePage} />
      <Route path="/embarcador/leilao" component={BuildingPage} />
      <Route path="/embarcador/favorito" component={EmbarcadoraFavoritoPage} />
      <Route path="/embarcador/colaborador" component={EmbarcadoraColaborador} />
      <Route path="/embarcador/grupos-acesso" component={EmbarcadoraGruposAcesso} />
      <ProtectedRoute path="/embarcador/relatorio" permission={["TRANSPORTADOR_LIST", "RELATORIO_LIST"]} component={BuildingPage} />
      <Route path="/embarcador/minha-empresa" component={EmbarcadoraPerfil} />
      <Route path="/embarcador/meu-perfil" component={EmbarcadoraMeuPerfil} />
      <Route path="/embarcador/patio" component={EmbarcadoraPatio} />
      <Route path="/embarcador/locais" component={EmbarcadoraLocais} />
    </Switch>
  );
}
